import { useState } from "react";

import Image from "next/image";

import { getReactionInfo } from "pages/[tenant]/g/components/Feed/components/Interactions/Components/Reactions";

import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import { LockIcon } from "shared/components/organisms/AppNotification/assets/icons/LockIcon";

import { UserPhotoContainer } from "./styles";

interface IUserPhotoProps {
  photoSrc: string;
  username: string;
  reaction?: string;
  showLockIcon?: boolean;
}

export const UserPhoto = ({
  photoSrc,
  username,
  reaction = null,
  showLockIcon = false,
}: IUserPhotoProps) => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  const hasImageToShow = !imageFailedToLoad && !!photoSrc;
  const shouldShowReaction = !!reaction;

  return (
    <UserPhotoContainer>
      {hasImageToShow ? (
        <Image
          alt=""
          src={photoSrc}
          width={32}
          height={32}
          onError={() => setImageFailedToLoad(true)}
        />
      ) : (
        <SimpleUserInitialsName fullName={username} />
      )}

      <div className="icon">
        {showLockIcon && <LockIcon />}

        {shouldShowReaction && getReactionInfo({ type: reaction as any })?.icon}
      </div>
    </UserPhotoContainer>
  );
};
